import axios from 'axios';
import { AUTH_URL } from '../../../vars';

/**
 * @namespace Auth
 * @description Авторизация (Page:/login)
 */
export default {
  state: {
    user: null,
    token: null,
    avatar: null,
    user_roles: {
      'moderator' : false,
      'expert' : false,
      'bs' : false,
      'msc_admin' : false,
      'conf_admin' : false,
      'mentor' : false,
      'user_administrator' : false,
      'ref_moderator' : false,
      'invite_administrator' : false,
      'kisi_user': false,      
    },
  },
  mutations: {
    UPDATE_USER(state, data) {
      state.user = data;

      if (data !== null) {
        try {
          for (var index = 0; index < data.role.length; index++) {
            const element = data.role[index];

            if (element.access_rights == 'moderator') {
              state.user_roles['moderator'] = true;
              // state.user_roles['bs'] = true;
              // state.user_roles['expert'] = true;
              // state.user_roles['user_administrator'] = true;
            }
            if (element.access_rights == 'expert') {
              state.user_roles['expert'] = true;
            };
            if (element.access_rights == 'bs') {
              state.user_roles['bs'] = true;
            };
            if (element.access_rights == 'msc_admin') {
              state.user_roles['msc_admin'] = true;
            };
            if (element.access_rights == 'conf_admin') {
              state.user_roles['conf_admin'] = true;
            };
            if (element.access_rights == 'mentor') {
              state.user_roles['mentor'] = true;
            };
            if(element.access_rights == 'user_administrator'){
              state.user_roles['user_administrator'] = true;
            }
            if (element.access_rights == 'ref_moderator') {
              state.user_roles['ref_moderator'] = true;
            };
            if (element.access_rights == 'invite_administrator') {
              state.user_roles['invite_administrator'] = true;
            };
            if (element.access_rights == 'kisi_user') {
              state.user_roles['kisi_user'] = true;
            };
          }
        } catch (ex) {
          console.log('ex ---> ', ex);
        }
      }
      else{
        state.user_roles = {
          'moderator' : false,
          'expert' : false,
          'bs' : false,
          'msc_admin' : false,
          'conf_admin' : false,
          'mentor' : false,
          'user_administrator' : false,
          'ref_moderator' : false,
          'invite_administrator' : false,
          'kisi_user': false,
        }
      }
    },

    UPDATE_AVATAR(state, data) {
      state.avatar = data.profiles[0].individual.photo;
    },
    UPDATE_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    /**
     * @property {Object} ctx Объект vuex
     * @property {Object} payload Содержит email и пароль
     * @return {Object} Объект с ошибкой или данными пользователя
     *
     * @memberof Auth
     */
    async AUTH(ctx, payload) {
      try {
        const { data } = await axios.post(`${AUTH_URL}login/`, payload);

        ctx.commit('UPDATE_TOKEN', data.token);
        localStorage.setItem('isLoggedIn', data.user);
        return data;
      } catch (e) {
        console.log(e);
        // messageHelper(e.detail, 'error', 6000, )
        throw e;
      }
    },
  },
  getters: {
    GETTERS_HAVE_ROLE: (state) => (name) => {
      return state.user_roles[name]
    },
    
    GETTERS_AVATAR(state) {
      return state.avatar;
    },
    GETTERS_CURRENT_USER(state) {
      return state.user;
    },
    GETTERS_TOKEN(state) {
      return state.token;
    },
  },
};
